/**
 * <pre>
 * Sharing module.
 *
 * This module is responsible for all Sharing related logic.
 *
 * Summary of responsibilities:
 *
 *  - defines app interface
 * </pre>
 *
 * @author Tim Loram
 * @module Sharing
 */

// Import all objects that make up a Sharing module.
import ActionTypes from './actionTypes.js';
import Actions from './actions.js';
import Reducer from './reducer.js';
import Selectors from './selectors.js';
import Components from './components.js';
import Config from './config/config.js';

/**
 * <pre>
 * Sharing public interface.
 *
 * All interactions between different app modules should only happen via this interface, so only export
 * components, methods etc. that you intend to be public.
 *
 * Allows us to more clearly define and document how an app module should behave.
 * </pre>
 *
 * @type {Object}
 * @property {Object} Components React components that this app renders.
 * @property {Object} Reducer Reducer that modify this modules state.
 * @property {Object} Config Configuration for this app module.
 */
const Interface = {
	Components: Components,
	Reducer: Reducer.rootReducer,
	Config: Config
}

export default Interface;